export const addSpace = (str: any) => {
    const country = process.env.REACT_APP_PROJECT_COUNTRY
    const formattedStr = country === "uk" ? str?.replace(/£(\d+)\s*pp/, "£$1 pp") :
        country === "ie" ? str?.replace(/€(\d+)\s*pp/, "€$1 pp")
            : str?.replace(/$(\d+)\s*pp/, "$$1 pp");
    return formattedStr;
}